import React, { useState, useEffect } from "react";
import DataTable from "../../components/DataTable";
import SnackbarAlert from "../../components/SnackbarAlert";
import { Box, TextField, Tooltip, Typography, Button, CircularProgress, Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { webEndPoint } from '../../constants/globalConstants';
import { makeRequest } from "../../services/api";
export default function StatePage() {
    const [states, setStates] = useState([]);
    const [search, setSearch] = useState("");
    const [openModal, setOpenModal] = useState(false);
    const [editState, setEditState] = useState(null);
    const [stateCode, setStateCode] = useState("");
    const [stateName, setStateName] = useState("");
    const [snackbar, setSnackbar] = useState(false);
    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        fetchstates();
    }, []);
    const fetchstates = async () => {
        setLoading(true);
        try {
            let url = webEndPoint + "states";
            const response = await makeRequest("get", url);
            if (response) {
                setStates(response?.data);
                setLoading(false);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const openAddModal = () => {
        setEditState(null);
        setStateName("");
        setStateCode("");
        setOpenModal(true);
    };
    const handleEdit = (state) => {
        setEditState(state);
        setStateCode(state.state_code);
        setStateName(state.state_name);
        setOpenModal(true);
    };
    const handleClose = () => {
        setOpenModal(false);
        setStateCode("");
        setStateName("");
    };
    const handleSave = async () => {
        if (!stateName.trim() || !stateCode.trim()) {
            setMessage("State Code & Name Required");
            setSnackbar(true);
            return;
        }
        setLoading(true);
        try {
            if (editState) {
                const stateEditData = {
                    state_name: stateName,
                    state_code: stateCode
                };
                try {
                    let url = webEndPoint + "states/" + editState.rfId;
                    const response = await makeRequest("put", url, stateEditData);
                    if (response) {
                        setLoading(false);
                        setMessage("State Updated Successfully");
                    }
                } catch (err) {
                    console.error(err);
                } finally {
                    setLoading(false);
                }
            } else {
                const stateAddData = {
                    state_name: stateCode,
                    state_code: stateName
                };
                try {
                    let url = webEndPoint + "states";
                    const response = await makeRequest("post", url, stateAddData);
                    if (response) {
                        setLoading(false);
                        setMessage("State Added Successfully");
                    }
                } catch (err) {
                    console.error(err);
                } finally {
                    setLoading(false);
                }
            }
            fetchstates();
            setSnackbar(true);
            setOpenModal(false);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const filteredState = states?.filter((d) =>
        d?.state_name?.toLowerCase().includes(search?.toLowerCase())
    );
    const columns = ["S.No", "State Code", "State Name", "Action"];
    const rows = filteredState?.map((district, index) => [index + 1, district.state_code, district.state_name,
    <Box>
        <Tooltip title="Edit State">
            <Button variant="contained" color="primary" onClick={() => handleEdit(district)}>Edit</Button>
        </Tooltip>
    </Box>
    ]);
    return (
        <Box sx={{ position: "relative" }}>
            {loading && (
                <Box sx={{ position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh", backgroundColor: "rgba(255,255,255,0.6)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 9999, }}>
                    <CircularProgress />
                </Box>
            )}
            <Typography variant="h6" sx={{ mb: 3, fontWeight: 500 }}>State Master</Typography>
            <Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, gap: 2, alignItems: { xs: "stretch", sm: "center" }, justifyContent: "space-between", mb: 2, width: "100%", }}>
                <TextField label="Search State" size="small" value={search} onChange={(e) => setSearch(e.target.value)} sx={{ width: { xs: "100%", sm: "70%", md: 600 } }} />
                <Button variant="contained" startIcon={<AddIcon />} onClick={openAddModal} sx={{ width: { xs: "100%", sm: "auto" }, }}>Add State</Button>
            </Box>
            <DataTable columns={columns} rows={rows} />
            <SnackbarAlert open={snackbar} setOpen={setSnackbar} message={message} />
            <Dialog open={openModal} onClose={handleClose} fullWidth maxWidth="sm">
                <DialogTitle> {editState ? "Edit State" : "Add State"}</DialogTitle>
                <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
                    <TextField label="State Code" value={stateCode} onChange={(e) => setStateCode(e.target.value)} sx={{ mt: 2 }} fullWidth />
                    <TextField label="State Name" value={stateName} onChange={(e) => setStateName(e.target.value)} sx={{ mt: 2 }} fullWidth />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button variant="contained" onClick={handleSave}>Save</Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
}